import styled from 'styled-components'

import Img from 'gatsby-image'

import { Container } from '~/components/global'
import bannerBg from '~/images/banner_bg.jpg'

export const HeaderWrapper = styled.header`
  background-image: url(${bannerBg});
  background-position: center;
  padding: 0px 0 160px;
  margin-bottom: 80px;
  height: 800px;
  clip-path: url(#hexagon-clip-path);

  @media (max-width: ${(props) => props.theme.screen.md}) {
    padding: 0px 0 220px;
    margin-bottom: 0;
  }

  @media (max-width: ${(props) => props.theme.screen.sm}) {
    padding: 0px 0 220px;
    clip-path: url(#mobile-hexagon-clip-path);
  }

  .svg {
    position: absolute;
    width: 0;
    height: 0;
  }
`

export const InsideContainer = styled.div`
  margin-top: -740px;
  position: relative;
  z-index: 10;
`

export const StyledContainer = styled(Container)`
  @media (max-width: ${(props) => props.theme.screen.md}) {
    margin-top: -180px;
    margin-bottom: 50px;
  }

  @media (min-width: ${(props) => props.theme.screen.md}) {
    position: absolute;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
  }

  @media (max-width: ${(props) => props.theme.screen.sm}) {
    margin-bottom: 20px;
    margin-top: -320px;
  }
`

export const StoreButtons = styled.div`
  .link-download {
    display: flex;
    .appleBtn {
      display: inline-block;
      margin-top: 5px;
      margin-right: 16px;
      height: 51px;
      margin-left: -6px;
    }
    .googleBtn {
      display: inline-block;
      height: 61px;
    }
  }

  @media (max-width: ${(props) => props.theme.screen.sm}) {
    .link-download {
      .appleBtn {
        flex: 1;
        margin-right: 0px;
      }
      .googleBtn {
        flex: 1;
      }
    }
  }
`

export const HeaderTextGroup = styled.div`
  margin: 0;
  padding: 80px 0 80px;
  @media (max-width: ${(props) => props.theme.screen.md}) {
    padding: 0;
  }
  @media (min-width: ${(props) => props.theme.screen.md}) {
    width: 98%;
  }

  h3 {
    margin: 0 0 10px;
    color: ${(props) => props.theme.color.white.regular};
    ${(props) => props.theme.typography.h3}
    @media (max-width: ${(props) => props.theme.screen.md}) {
      font-size: 36px;
      line-height: 46px;
    }
  }

  h5 {
    margin: 0 0 59px;
    ${(props) => props.theme.typography.h5}
    color: ${(props) => props.theme.color.white.regular};
  }

  p {
    margin-bottom: 48px;
  }
`

export const Flex = styled.div`
  display: grid;
  justify-content: space-between;
  align-content: center;
  grid-template-columns: 1fr 1fr;
  @media (max-width: ${(props) => props.theme.screen.md}) {
    grid-template-columns: 1fr;
    grid-gap: 64px;
  }
`

export const ImageWrapper = styled.div`
  justify-self: end;
  align-self: center;
  z-index: 2;
  position: relative;

  @media (max-width: ${(props) => props.theme.screen.lg}) {
    right: 0;
  }
`

export const StyledImage = styled(Img)`
  width: 627px;
  margin: 0px 0px 0px auto;

  @media (max-width: ${(props) => props.theme.screen.lg}) {
    width: 500px;
  }

  @media (max-width: ${(props) => props.theme.screen.md}) {
    width: auto;
  }
`
